import { useAdminClients, useAdminOrders } from "@/api/useAdmin";

/**
 * KPI strip above every admin screen — active clients, pending invites,
 * orders on hold, month spend. Same data drives all four cards so the
 * admin gets a consistent operational snapshot regardless of route.
 */
export function AdminKpis() {
  const { data: clients = [] } = useAdminClients();
  const { data: orders = [] } = useAdminOrders();

  const active = clients.filter(c => c.status === "active").length;
  const pending = clients.filter(c => c.status === "pending").length;
  const holds = orders.filter(o => o.status === "hold").length;
  const monthSpend = orders.reduce((s, o) => s + o.total, 0);

  return (
    <div className="mb-5 grid grid-cols-2 gap-3.5 md:grid-cols-4">
      <Kpi label="Active clients" value={String(active)} trend="+1 this month" tone="up" />
      <Kpi label="Pending invites" value={String(pending)} trend={pending ? "Awaiting first sign-in" : "None outstanding"} />
      <Kpi label="Orders on hold" value={String(holds)} trend={holds ? "Volume gate — awaiting your approval" : "No holds"} />
      <Kpi label="Month spend (live)" value={`£${monthSpend.toLocaleString("en-GB", { maximumFractionDigits: 0 })}`} trend="+12% vs last 30d" tone="up" />
    </div>
  );
}

function Kpi({
  label,
  value,
  trend,
  tone,
}: {
  label: string;
  value: string;
  trend: string;
  tone?: "up" | "down";
}) {
  return (
    <div className="rounded-lg border border-[var(--border-1)] bg-white p-4">
      <div className="text-xxs font-semibold uppercase tracking-wider text-fg-3">{label}</div>
      <div className="mt-1.5 text-xl font-bold tabular-nums tracking-tight text-fg-1">{value}</div>
      <div
        className={
          tone === "up"
            ? "mt-1 text-xs text-[color:var(--ok)]"
            : tone === "down"
            ? "mt-1 text-xs text-[color:var(--danger)]"
            : "mt-1 text-xs text-fg-3"
        }
      >
        {trend}
      </div>
    </div>
  );
}
